import { useTranslation } from "react-i18next";
import stepsStyles from "../steps.module.css";

function Row({ label, value }) {
  if (!value) return null;
  return (
    <div style={{ display: "flex", gap: 12, padding: "6px 0", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
      <span style={{ color: "var(--text-muted)", fontSize: "0.82rem", minWidth: 140 }}>{label}</span>
      <span style={{ color: "var(--text-primary)", fontSize: "0.82rem" }}>{value}</span>
    </div>
  );
}

export default function StepConfirmacion({ formData, errors = {} }) {
  const { t } = useTranslation();

  const TIPO_LABEL = {
    FISICA: t("proveedores.tipoFisica"), JURIDICA: t("proveedores.tipoJuridica"), DIMEX: "DIMEX",
    NITE: "NITE", PASAPORTE: t("proveedores.tipoPasaporte"),
    EXTRANJERO: t("proveedores.tipoExtranjero"), OTRO: t("proveedores.tipoOtro"),
  };

  const direccion = [formData.dir_provincia, formData.dir_canton, formData.dir_distrito]
    .filter(Boolean).join(", ");

  return (
    <div className="step">
      <h3 className="p-0 mt-2 mb-0 title" style={{ fontSize: "1.3rem" }}>
        {t("proveedores.confirmacionTitulo")}
      </h3>
      <p className={`${stepsStyles.inactive} mb-3`} style={{ fontSize: "1rem" }}>
        {t("proveedores.confirmacionSubtitulo")}
      </p>

      {errors._global && (
        <div style={{
          background: "rgba(239,68,68,0.08)", border: "1px solid rgba(239,68,68,0.35)",
          borderLeft: "4px solid #ef4444", borderRadius: 8,
          padding: "10px 16px", marginBottom: 14, color: "#f87171", fontSize: "0.83rem",
        }}>
          <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: 6 }} />
          {errors._global}
        </div>
      )}

      <div style={{ background: "var(--bg)", borderRadius: 8, padding: "14px 16px", marginBottom: 14 }}>
        <p style={{ color: "#f97316", fontWeight: 700, fontSize: "0.75rem", textTransform: "uppercase",
          letterSpacing: "0.5px", marginBottom: 8 }}>{t("proveedores.stepIdentificacion")}</p>
        <Row label={t("proveedores.tipoIdentificacion")} value={TIPO_LABEL[formData.tipo_cedula] || formData.tipo_cedula} />
        <Row label={t("proveedores.numeroIdentificacion")} value={formData.cedula || "-"} />
        <Row label={t("proveedores.nombreRazonSocial")} value={formData.nombre} />
        <Row label={t("proveedores.colEstado")} value={formData.activo ? t("proveedores.activo") : t("proveedores.inactivo")} />
      </div>

      {(formData.email || formData.contacto || formData.telefonos?.length > 0) && (
        <div style={{ background: "var(--bg)", borderRadius: 8, padding: "14px 16px", marginBottom: 14 }}>
          <p style={{ color: "#f97316", fontWeight: 700, fontSize: "0.75rem", textTransform: "uppercase",
            letterSpacing: "0.5px", marginBottom: 8 }}>{t("proveedores.stepContacto")}</p>
          <Row label="Email" value={formData.email} />
          <Row label={t("proveedores.contactoRef")} value={formData.contacto} />
          {formData.telefonos?.map((tel, i) => (
            <Row key={i} label={`${t("proveedores.telefonos")} ${i + 1}`} value={`${tel.codigo_pais} ${tel.numero} (${tel.tipo})`} />
          ))}
        </div>
      )}

      {(direccion || formData.dir_senas) && (
        <div style={{ background: "var(--bg)", borderRadius: 8, padding: "14px 16px", marginBottom: 14 }}>
          <p style={{ color: "#f97316", fontWeight: 700, fontSize: "0.75rem", textTransform: "uppercase",
            letterSpacing: "0.5px", marginBottom: 8 }}>{t("proveedores.stepDireccion")}</p>
          <Row label={t("proveedores.ubicacion")} value={direccion} />
          <Row label={t("proveedores.senasEspecificas")} value={formData.dir_senas} />
        </div>
      )}

      {formData.observaciones && (
        <div style={{ background: "var(--bg)", borderRadius: 8, padding: "14px 16px" }}>
          <p style={{ color: "#f97316", fontWeight: 700, fontSize: "0.75rem", textTransform: "uppercase",
            letterSpacing: "0.5px", marginBottom: 8 }}>{t("proveedores.observaciones")}</p>
          <p style={{ color: "var(--text-muted)", fontSize: "0.82rem", margin: 0 }}>{formData.observaciones}</p>
        </div>
      )}
    </div>
  );
}
